// removed by extract-text-webpack-plugin
module.exports = {"Footer":"_1FL9MexFCBWUtchy9KsrIa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/styles.css
// module id = 748
// module chunks = 0